import React, { useEffect, useRef } from "react";
import PageHelmet from "../Helper/PageHelmet";
import Header from "../Helper/Header";
import ProductCapabilites from "../ProductCap/ProductCapabilites";
import ContactForm from "../ContactForm/ContactForm";
import IndustryLeaders from "../IndustryLeaders/IndustryLeaders";
import NextGenAI from "../NextGenAI/NextGenAI";
import ProductOffering from "../ProductOffering/ProductOffering";
import Packages from "../packages/Packages";
import HomeBanner from "../HomeBanner/HomeBanner";
import IntegratedPlanning from "../IntegratedPlanning/IntegratedPlanning";
import CoreComponents from "../CoreComponents/CoreComponents";
import NewFooter from "../Helper/NewFooter";
import LaunchTicker from "../Helper/LaunchTicker";
import HiringBanner from "../HiringBanner/HiringBanner";

const Home = ({ section }) => {
  const contact2Ref = useRef(null);
  const technology2Ref = useRef(null);
  const products2Ref = useRef(null);
  const solutions2Ref = useRef(null);
  const offerings2Ref = useRef(null);
  const blogsPage2Ref = useRef(null);
  const careers2Ref = useRef(null);

  useEffect(() => {
    // Function to handle scrolling based on the section prop
    const scrollToSection = () => {
      if (section === "industries" && products2Ref.current) {
        solutions2Ref.current.scrollIntoView({ behavior: "smooth" });
      }
      if (section === "offerings" && products2Ref.current) {
        offerings2Ref.current.scrollIntoView({ behavior: "smooth" });
      }
      if (section === "technology" && technology2Ref.current) {
        technology2Ref.current.scrollIntoView({ behavior: "smooth" });
      }

      if (section === "products" && products2Ref.current) {
        products2Ref.current.scrollIntoView({ behavior: "smooth" });
      }


    };
    setTimeout(() => {
      requestAnimationFrame(scrollToSection);
    }, 333);
  }, [section]);

  return (
    <>
      <PageHelmet pageTitle="Home" />
      <Header />
      {/* <LaunchTicker /> */}
      <HomeBanner />
      <div ref={solutions2Ref}>
        <IndustryLeaders />
      </div>
      <div ref={technology2Ref}>
        <NextGenAI />
      </div>

      <ProductCapabilites />

      <CoreComponents />
      <IntegratedPlanning />
      <div ref={products2Ref}>
        <Packages />
        {/* <Packages /> */}
      </div>
      <div ref={offerings2Ref}>
        <ProductOffering />
      </div>
      <div ref={contact2Ref}>
        <ContactForm showFooter={false} />
      </div>
      {/* <div ref={careers2Ref}>
      <HiringBanner showCareer={false} /> 
      </div> */}
      <NewFooter />
    </>
  );
};

export default Home;
